import React from 'react';

const receive = 'Возврат';

const SubRows = ({ row, rowProps, visibleColumns, data, loading, onClick }) => {
  if (loading) {
    return (
      <tr>
        <td />
        <td colSpan={visibleColumns.length - 1}>Загрузка...</td>
      </tr>
    );
  }

  return (
    <>
      {data.map((x, i) => {
        return (
          <tr {...rowProps} key={`${rowProps.key}-expanded-${i}`} className="brightness">
            {row.cells.map((cell) => {
              const click = x.type === receive ? onClick : () => {};
              return (
                <th className="sub-cell" {...cell.getCellProps()} onClick={() => click(x)}>
                  {cell.render(cell.column.SubCell ? 'SubCell' : 'Cell', {
                    value: cell.column.accessor && cell.column.accessor(x, i),
                    row: { ...row, original: x },
                  })}
                </th>
              );
            })}
          </tr>
        );
      })}
    </>
  );
};

export { SubRows };
